import React, { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import useWalletDetails from 'api/useWalletDetails'
import { copyTextToClipboard } from 'lib/clipboard'
import useStore from 'state/knovStore'
import { BsvWalletType } from 'wallets/wallets'
import styles from 'components/quests/confirm.module.scss'

export default function TopUpWalletAddress() {
    const walletType = useStore(state => state.currentUserBsvWalletType) || BsvWalletType.SHUALLET
    const { data: walletDetails } = useWalletDetails(walletType)
    const [copied, setCopied] = useState(false)
    const [pandaDisplayAddress, setPandaDisplayAddress] = useState('')

    React.useEffect(() => {
        let cancelled = false

        if (
            walletType !== BsvWalletType.PANDA ||
            typeof window === 'undefined' ||
            !window.panda?.getAddresses
        ) {
            setPandaDisplayAddress('')
            return () => {
                cancelled = true
            }
        }

        window.panda
            .getAddresses()
            .then(addresses => {
                if (!cancelled) {
                    setPandaDisplayAddress(addresses?.bsvAddress || '')
                }
            })
            .catch(error => {
                console.warn('Failed to load Panda wallet funding address.', error)
            })

        return () => {
            cancelled = true
        }
    }, [walletType])

    const address =
        walletType === BsvWalletType.PANDA
            ? pandaDisplayAddress || walletDetails?.address || ''
            : walletDetails?.address || ''

    const handleCopyAddress = async () => {
        if (!address) return

        if (await copyTextToClipboard(address)) {
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
            return
        }

        alert('Failed to copy to clipboard')
    }

    return (
        <div className={styles.fundWalletAddress}>
            <span>Fund your wallet</span>
            {address ? (
                <button
                    type="button"
                    className={styles.fundWalletAddressButton}
                    title={copied ? 'Copied' : `Copy ${address}`}
                    aria-label={copied ? 'Copied wallet address' : 'Copy wallet address'}
                    onClick={handleCopyAddress}
                >
                    <span>{address}</span>
                    {copied ? <Check size={14} aria-hidden /> : <Copy size={14} aria-hidden />}
                </button>
            ) : (
                <span className={styles.fundWalletAddressLoading}>Loading address...</span>
            )}
        </div>
    )
}
